import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import { AuthProvider } from './contexts/AuthContext';
import { payResultHandoff } from './lib/payments';
import './index.css';
import './design/focus.css';

// JTPay sends a student back to /pay/result?reference=<ref>, which the server answers with this
// app. Swap the address for the result page's before the first render, so the hash router opens
// it and a reload keeps it (JTP-20). Nothing reloads: the same page serves both addresses.
const payResult = payResultHandoff(window.location);
if (payResult) window.history.replaceState(null, '', payResult);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
